<template src="../templates/form.html"></template>

<script>
import {useStore, mapGetters, mapMutations} from 'vuex';
import FormInput from '../entities/FormInput';
import Selection from '../entities/Selection';

export default {
  name: 'Form',
  components: {
    FormInput,
    Selection,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    v: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  computed: {
    ...mapGetters([
      'fieldDeps',
      'searchTownItems',
      'searchStreetItems',
      'estimatedDeliveryDate'
    ]),
  },
  methods: {
    ...mapMutations([
      'setTown',
      'setStreet',
      'setFormErrors'
    ]),
    async updateForm(payload) {
      this.store.commit('updateForm', payload);
    },
    validateField(fieldName) {
      this.v.form[fieldName].$touch();
    },
    load(type, {target}) {
      this.store.dispatch('loadAddress', {type, value: target.value});
    },
  },
};
</script>

<style scoped>
.region-label {
  color: #888;
}
</style>
